import { IBaseIconProps } from "./IBaseIconProps";

export const PlusIcon2 = ({ color = "#fff" }: IBaseIconProps) => {
  return (
    <svg width="16" height="16" fill="none" stroke={color} viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
        color={color}
      />
    </svg>
  );
};
